<template>
  <OrderQuery breadcrumbTitle="Returned" query="?status=ReturnCar" />
</template>

<script>
import OrderQuery from '@/components/order/OrderQuery.vue';

export default {
  name: 'OrderReturned',
  components: {
    OrderQuery,
  },
};
</script>

<style></style>
